export default {
  base: 'cursor-pointer',
  variants: {
    active: {
      false: 'text-(--ui-text)',
    },
  },
}